import React from "preact";

function BackArrow() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 18 18"
    >
      <path
        fill="#333"
        d="M13.5 3.1V1.545a.16.16 0 00-.26-.126L4.186 8.493a.64.64 0 000 1.01l9.056 7.074a.16.16 0 00.259-.126v-1.553a.325.325 0 00-.123-.253L6.145 9l7.232-5.648A.325.325 0 0013.5 3.1z"
      ></path>
    </svg>
  );
}

export default BackArrow;
